<template>
  <div
    ref="media"
    class="media"
    :style="{
      'background-image':
        primaryMedia?.blurry && `url(${primaryMedia?.blurry})`,
    }"
  >
    <template v-if="showMedia">
      <Transition v-if="isVideo(primaryMedia)" name="fade">
        <video
          v-show="mediaLoaded"
          loop
          muted
          playsinline
          disableRemotePlayback
          preload="none"
          autoplay
          @loadeddata="onMediaLoaded"
        >
          <source
            v-for="source in primaryMedia.sources"
            :key="source.url"
            :src="source.url"
            :type="source.mimeType"
          />
          Your browser does not support the video tag.
        </video>
      </Transition>
      <Transition v-else name="fade">
        <picture v-show="mediaLoaded">
          <source
            v-if="largeMediaPrimary"
            :srcset="largeMediaPrimary"
            media="(min-width: 821px)"
          />
          <source
            v-if="mediumMediaPrimary"
            :srcset="mediumMediaPrimary"
            media="(min-width: 429px)"
          />
          <source :srcset="smallMediaPrimary" media="(max-width: 428px)" />
          <img
            :src="primaryMedia.smallMedia"
            :alt="primaryMedia.altText"
            class="media__image media__image--primary"
            @load="onMediaLoaded"
          />
        </picture>
      </Transition>
      <Transition v-if="secondaryMedia" name="fade">
        <picture v-show="hover">
          <source
            v-if="largeMediaSecondary"
            :srcset="largeMediaSecondary"
            media="(min-width: 821px)"
          />
          <source
            v-if="mediumMediaSecondary"
            :srcset="mediumMediaSecondary"
            media="(min-width: 429px)"
          />
          <source :srcset="smallMediaSecondary" media="(max-width: 428px)" />
          <img
            :src="secondaryMedia.smallMedia"
            :alt="secondaryMedia.altText"
            class="media__image media__image--secondary"
          />
        </picture>
      </Transition>
    </template>
  </div>
</template>

<script>
export default {
  name: "ProductCardMedia",
  props: {
    primaryMedia: {
      type: Object,
      default: () => ({}),
    },
    secondaryMedia: {
      type: Object,
      default: null,
    },
    hover: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      observer: null,
      intersected: false,
      mediaLoaded: false,
    };
  },
  computed: {
    showMedia() {
      return this.intersected;
    },
    largeMediaPrimary() {
      return this.generateSrcset(
        this.primaryMedia.largeMedia,
        this.primaryMedia.largeMedia2x
      );
    },
    mediumMediaPrimary() {
      return this.generateSrcset(
        this.primaryMedia.mediumMedia,
        this.primaryMedia.mediumMedia2x
      );
    },
    smallMediaPrimary() {
      return this.generateSrcset(
        this.primaryMedia.smallMedia,
        this.primaryMedia.smallMedia2x
      );
    },
    largeMediaSecondary() {
      return this.generateSrcset(
        this.secondaryMedia.largeMedia,
        this.secondaryMedia.largeMedia2x
      );
    },
    mediumMediaSecondary() {
      return this.generateSrcset(
        this.secondaryMedia.mediumMedia,
        this.secondaryMedia.mediumMedia2x
      );
    },
    smallMediaSecondary() {
      return this.generateSrcset(
        this.secondaryMedia.smallMedia,
        this.secondaryMedia.smallMedia2x
      );
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(
      this.handleIntersection,
      this.options
    );
    this.observer.observe(this.$refs.media);
  },
  methods: {
    generateSrcset(src, src2x) {
      return src2x ? `${src} 1x, ${src2x} 2x` : src;
    },
    onMediaLoaded() {
      this.mediaLoaded = true;
    },
    handleIntersection([entry]) {
      if (entry && entry.isIntersecting) {
        this.intersected = true;
      }
    },
    isVideo(media) {
      return media.mediaContentType === "VIDEO" || media.sources?.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.media {
  height: 100%;
  position: relative;
  background-size: cover;
  background-position: center center;

  img,
  video {
    max-width: 100%;
    height: auto;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: "center center";
  }

  &__image--secondary {
    position: absolute;
    top: 0;
    left: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
